/// <reference path="../../index.d.ts" />
import axios from 'axios';

//@ts-ignore
import * as securitypackage from '../../source/js/securitypackage-api';
import {
	getURLParameterByName,
	cookie,
	fromStringToBoolean,
} from '../../../shared/utils';
import { API_PLATFORM_ENDPOINT } from '../../constants';


const authApi = {
	security: {
		authenticationService: {
			client: new securitypackage.AuthenticationServiceClient() as AuthenticationServiceClient,
			requestPasswordRecovery: (login: string) => {
				return new Promise<SuccessMessage>(resolve => {
					authApi.security.authenticationService.client.requestPasswordRecovery(login, result => {
						resolve(result);
					});
				});
			},
			recoverPassword: (code: string, newPassword: string, login: string) => {
				return new Promise<SuccessMessage>(resolve => {
					authApi.security.authenticationService.client.recoverPassword(code, newPassword, login, result => {
						resolve(result);
					});
				});
			},
			changePassword: (login: string, oldPassword: string, newPassword: string) => {
				return new Promise<SuccessMessage>(resolve => {
					authApi.security.directoryService.client.changeUserPassword(login, oldPassword, newPassword, result => {
						resolve(result);
					});
				});
			},
			login: (options: LoginOptions) => {
				const {
					login,
					password,
					businessServiceID,
					postActionURL,
					systemName,
					fallbackUrl,
				} = options;

				return new Promise<boolean>(resolve => {
					const form = document.createElement('form');
					const attrs = {
						'requestedAction': 'login',
						'postActionURL': postActionURL,
						'business_service_id': businessServiceID,
						'system_name': systemName,
						'user_login': login,
						'user_password': password,
						'fallbackUrl': fallbackUrl,
						'hash': '423b3c9d7b33fa38fabe1fb5b9b79e38e10fb632ea177e0b0dbba0c9d82bc57c',
					};

					form.setAttribute('method', 'post');
					form.setAttribute('action', `${API_PLATFORM_ENDPOINT}/login`);

					for (const attrName of Object.keys(attrs)) {
						const attrValue = attrs[attrName];
						const element = document.createElement('input');

						element.setAttribute('type', 'hidden');
						element.setAttribute('name', attrName);
						element.setAttribute('value', attrValue.toString());
						form.appendChild(element);
					}

					document.body.appendChild(form);
					form.submit();
					resolve(true);
				});
			}
		},
		registrationService: {
			client: new securitypackage.RegistrationServiceClient() as RegistrationServiceClient,
			validateLogin: (login: string) => {
				return new Promise<boolean>(resolve => {
					authApi.security.registrationService.client.validateLogin(login, result => {
						resolve(fromStringToBoolean(result));
					});
				});
			},
			validateLoginForBusinessService: (login: string, businessServiceCode: string) => {
				return new Promise<boolean>(resolve => {
					authApi.security.registrationService.client.validateLoginForBusinessService(login, businessServiceCode, result => {
						resolve(fromStringToBoolean(result));
					});
				});
			},
			registerAccount: (options: RegisterAccountOptions) => {
				const {
					login,
					contactName,
					phoneNumber,
					postActionURL,
					tariffCode = '',
					provider,
					businessService,
					clientApplication,
					yandexClientID,
					onBeforeSubmit,
				} = options;

				return new Promise<boolean>(async resolve => {
					const isValid = await authApi.security.registrationService.validateLoginForBusinessService(login, businessService);

					if (isValid) {
						const form = document.createElement('form');
						const searchMap = new URLSearchParams(location.search) as any;
						const attrs = {
							'change-password-after-registration': false,
							provider,
							postActionURL,
							tariffCode: tariffCode,
							contactPersonEMail: login,
							contactPersonPhone: phoneNumber,
							contactPersonName: contactName,
							auth_method: 'login_pass',
							business_service: businessService,
							client_app: clientApplication,
							ym_client_id: yandexClientID,
							reg_url: encodeURIComponent(location.href),
							reg_signup_url: encodeURIComponent(location.href),
						};

						for (const search of searchMap) {
							const [name, value] = search;
							const attrName = `reg_${name}`;

							attrs[attrName] = value;
						}

						form.setAttribute('method', 'post');
						form.setAttribute('action', `/atr-framework-services/registration`);

						for (const attrName of Object.keys(attrs)) {
							const attrValue = attrs[attrName] + '';
							const element = document.createElement('input');

							element.setAttribute('type', 'hidden');
							element.setAttribute('name', attrName);
							element.setAttribute('value', attrValue);
							form.appendChild(element);
						}

						document.body.appendChild(form);

						typeof onBeforeSubmit === 'function' && onBeforeSubmit();

						form.submit();
					}

					resolve(isValid);
				});
			},
			registerLeadTransition: (partnerTenantID: number) => {
				const transition = { ...new securitypackage.RegisterLeadTransitionRequest(), PartnerTenantID: partnerTenantID } as RegisterLeadTransitionRequest
				return new Promise<boolean>(resolve => {
					authApi.security.registrationService.client.registerLeadTransition(transition, result => {
						resolve(fromStringToBoolean(result));
					});
				});
			},
		},
		directoryService: {
			client: new securitypackage.DirectoryServiceClient() as DirectoryServiceClient,
			getPartnerStatus: () => {
				const request = new securitypackage.PartnerStatusRequest() as PartnerStatusRequest
				return new Promise<PartnerStatus>(resolve => {
					authApi.security.directoryService.client.getPartnerStatus(request, result => {
						resolve(result);
					});
				});
			},
		},
		rest: {
			fetchSessionContext: (ticketUID: string) => {
				return new Promise<ClientSessionContext>(resolve => {
					axios({
						method: 'get',
						url: `${API_PLATFORM_ENDPOINT}/clientSessionContext?ticketuid=${ticketUID}`
					}).then((response) => {
						resolve(response.data);
					});
				});
			}
		}
	},
	checkAuth: () => {
		return new Promise<[boolean, string]>(resolve => {
			const TICKET_UID_VARIABLE = window['TICKET_UID_VARIABLE'];
			const ticketUID = getURLParameterByName(TICKET_UID_VARIABLE) || cookie.get(TICKET_UID_VARIABLE) || localStorage.getItem(TICKET_UID_VARIABLE);

			window['pageContext'][TICKET_UID_VARIABLE] = ticketUID;
			window['pageContext'][window['WEB_SERVICES_ROOT_VARIABLE']] = location.origin;
			window['showErrorMessage'] = () => { };

			authApi.security.rest.fetchSessionContext(ticketUID).then(context => {
				const isContextExists = Boolean(context) && Object.keys(context).length > 0;

				if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
					isContextExists && localStorage.setItem(TICKET_UID_VARIABLE, ticketUID);
				}

				resolve([isContextExists, ticketUID]);
			});
		});
	},

	logout: (options: LogoutOptions) => {
		const {
			businessService,
		} = options;

		const form = document.createElement('form');
		const TICKET_UID_VARIABLE = window['TICKET_UID_VARIABLE'];
		localStorage.setItem(TICKET_UID_VARIABLE, '');

		const attrs = {
			business_service: businessService,
		};
		form.setAttribute('method', 'post');
		form.setAttribute('action', '/atr-framework-services/logout');

		for (const attrName of Object.keys(attrs)) {
			const attrValue = attrs[attrName] + '';
			const element = document.createElement('input');
			element.setAttribute('type', 'hidden');
			element.setAttribute('name', attrName);
			element.setAttribute('value', attrValue);
			form.appendChild(element);
		}

		document.body.appendChild(form);
		form.submit();
	},
};

type LoginOptions = {
	login: string;
	password: string;
	postActionURL: string;
	businessServiceID: number;
	systemName: string;
	fallbackUrl: string;
};

type RegisterAccountOptions = {
	login: string;
	phoneNumber: string;
	contactName: string;
	postActionURL: string;
	tariffCode: string;
	provider: string;
	businessService: string;
	clientApplication: string;
	yandexClientID?: string;
	onBeforeSubmit?: () => void;
};

type LogoutOptions = {
	businessService: string;
};

export default authApi;
